var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLuggage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_902_2484)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_902_2484)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_902_2484",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -615,
    y: -1212,
    width: 1441,
    height: 4421
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M825.795 -1211.9H-614.205V3208.1H825.795V-1211.9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_902_2484)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.794922 13.5956C0.794922 15.5384 2.32548 17.1035 4.22548 17.1035H16.3643C18.2643 17.1035 19.7949 15.5384 19.7949 13.5956V6.57971C19.7949 4.63685 18.2643 3.07177 16.3643 3.07177H14.3324C14.0685 1.39876 12.6699 0.103516 10.9546 0.103516H9.6352C7.91992 0.103516 6.49492 1.39876 6.25742 3.07177H4.22548C2.32548 3.07177 0.794922 4.63685 0.794922 6.57971V13.5956ZM9.6352 1.72257H10.9546C11.7991 1.72257 12.4852 2.28923 12.7227 3.07177H7.86714C8.10464 2.28923 8.79075 1.72257 9.6352 1.72257ZM16.3643 4.69082H4.22548C3.19631 4.69082 2.37825 5.52733 2.37825 6.57971V8.00987H18.2116V6.57971C18.2116 5.52733 17.3935 4.69082 16.3643 4.69082ZM16.3643 15.4845H4.22548C3.19631 15.4845 2.37825 14.6479 2.37825 13.5956V9.62892H7.2602V10.6273C7.2602 11.6797 8.07825 12.5162 9.10742 12.5162H11.4824C12.5116 12.5162 13.3296 11.6797 13.3296 10.6273V9.62892H18.2116V13.5956C18.2116 14.6479 17.3935 15.4845 16.3643 15.4845ZM11.7463 9.62892H8.84353V10.6273C8.84353 10.7892 8.94909 10.8972 9.10742 10.8972H11.4824C11.6407 10.8972 11.7463 10.7892 11.7463 10.6273V9.62892Z",
    fill: "#12BF66"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_902_2484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 17,
    fill: "white",
    transform: "translate(0.794922 0.103516)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_902_2484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 17,
    fill: "white",
    transform: "translate(0.794922 0.103516)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggage);
export default __webpack_public_path__ + "static/media/luggage.386242927b73f9754487d895843f454e.svg";
export { ForwardRef as ReactComponent };